export const appBlue = '#142242'
export const appRed = '#E63131'
export const appGold = '#E0BF92'
export const lightGrey = '#CDCED2' // border
export const darkGrey = '#8C8C8C'
export const black = '#222222'
export const blue = '#1e72d9'
export const green = '#44ac35'
